import OneColumnTemplate from "./oneColumnTemplate";

export default OneColumnTemplate;
